import http from '@/api/HttpHelper'

const state = {
    mappings: [],
    loadingMappings: false
}

const getters = {
    mappings (state) {
        return state.mappings
    },
    loadingMappings (state) {
        return state.loadingMappings
    }
}

const mutations = {
    setCompanyMappings (state, mappings) {
        state.mappings = mappings
    },
    setLoadingMappings (state, isLoading) {
        state.loadingMappings = isLoading
    },
    removeBranch (state, branch) {
        const index = state.mappings.indexOf(branch)
        state.mappings.splice(index, 1)
    }
}

const actions = {
    async getCompanyMappings ({ commit }) {
        commit('setLoadingMappings', true)
        const result = await http.get('/productmapping')
        commit('setCompanyMappings', result.data)
        commit('setLoadingMappings', false)
    },
    async saveGiftcardProduct({ dispatch }, product) {
        await http.post('/productmapping/giftcard', product)
        dispatch('getCompanyMappings')
    },
    async deleteGiftcardProduct({ dispatch }, product) {
        await http.delete(`/productmapping/giftcard/${product.id}`)
        dispatch('getCompanyMappings')
    },
    async saveProduct({ dispatch }, product) {
        const wrappedProduct = {entity: product, originalId: product.originalId}
        await http.post('productmapping/product', wrappedProduct)
        dispatch('getCompanyMappings')
    },
    async deleteProduct({ dispatch }, product) {
        await http.delete(`/productmapping/product/${product.id}`)
        dispatch('getCompanyMappings')
    },
    async saveBranch({ dispatch }, branch) {
        const wrappedBranch = {entity: branch, originalId: branch.originalId}
        await http.post('productmapping/branch', wrappedBranch)
        dispatch('getCompanyMappings')
    },
    async deleteBranch({ commit }, branch) {
        await http.delete(`/productmapping/branch/${branch.id}`)
        commit('removeBranch', branch)
    }

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}